class Utilities {

	static base64_encode(str) {
		return window.btoa(decodeURIComponent(encodeURIComponent(str)));
	}

	static base64_decode(str) {
		return decodeURIComponent(encodeURIComponent(window.atob(str)));
	}

	static getPlayerCurrencySymbol(currency) {
		switch (currency.toLowerCase()) {
			case 'usd':
				return "$";
			case 'eur':
				return "€";
			case 'cad':
				return "C$";
			case 'zar':
				return "R";
			default:
				return "$";
		}
	}

	static changeUrlParameteForWhitespaceIframe(depositMethod) {
		if (depositMethod === "cc") {
			return "CC";
		} else if (depositMethod === "neteller") {
			return "NETeller";
		} else if (depositMethod === "skrill") {
			return "Skrill";
		} else if (depositMethod === "flexepin") {
			return "Flexepin";
		} else if (depositMethod === "interac") {
			return "INTERAC";
		} else if (depositMethod === "other") {
			return "other";
		}
		return null;
	}

	static replaceAll(originalString, searchFor, replaceWith) {
		return originalString.replace(new RegExp(searchFor, 'g'), replaceWith);
	}
}

module.exports = Utilities;